import { createContext } from '@direct-frontend/modules-context';
import { ExperimentsFlags } from './types';

export interface ExperimentsContext {
    experimentsFlags: ExperimentsFlags;
    experimentsBoxesCrypted: string | undefined;
    experimentsBoxes: string[] | undefined;
}

export const { setContext: setExperimentsContext, getContext: getExperimentsContext } =
    createContext<ExperimentsContext>({
        name: 'experimentsContext',
    });

export const createEmptyExperimentsContext = (): ExperimentsContext => ({
    experimentsFlags: {},
    experimentsBoxesCrypted: undefined,
    experimentsBoxes: undefined,
});

export const getSafeExperimentsContext = (): ExperimentsContext => {
    try {
        return getExperimentsContext();
    } catch (_) {
        return createEmptyExperimentsContext();
    }
};
